<template>
    <div class="Tabs">
        <a
            v-for="tab in tabs"
            :key="tab.key"
            class="Tab"
            :class="{ Selected: tab.key === value, disabled: tab.disabled }"
            @click="!tab.disabled && $emit('input', tab.key)"
        >
            <WText
                tag="span"
                typo="span"
                class="TabText"
                align="center"
                :size="size"
            >
                {{ tab.text }}
            </WText>
        </a>
    </div>
</template>

<script>
import VueTypes from 'vue-types'

export default {
    name: 'Tabs',
    props: {
        tabs: VueTypes.arrayOf(VueTypes.shape({
            key: VueTypes.string,
            text: VueTypes.string,
            disabled: VueTypes.boolean,
        }).loose).isRequired,
        value: VueTypes.string.isRequired,
        size: VueTypes.oneOfType([VueTypes.string, VueTypes.number]).def(14),
    },
}
</script>

<style lang="scss" scoped>
.Tabs {
    display: flex;
    background-color: $gray-06;
    border-radius: $border-radius;
    box-sizing: border-box;
    overflow: hidden;
    padding: 4px;
    gap: 4px;
}

.Tab {
    position: relative;
    display: flex;
    align-items: center;
    padding: 8px 20px;
    cursor: pointer;
    border-radius: $border-radius;
    font-family: $font-family-sans-serif;
    font-weight: $font-weight-semibold;
    transition: all .3s ease-in-out;
    background-color: transparent;
    color: $gray-02;

    &.disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    &:not(.disabled):hover {
        color: $accent-blue;
        background-color: rgba($accent-blue, .1);
    }
    
    &.Selected {
        color: $black;
        background-color: $white;
        box-shadow: 0 2px 4px rgba($black, 0.08);

        &:hover{
            color: $black;
            background-color: $white;
        }
    }
}
.TabText {
    color: inherit !important;
    transition: all .3s ease-in-out;
}

</style>
